var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$store.state.isLogged)?_c('Header'):_vm._e(),(_vm.$store.state.navMenu)?_c('Menu'):_vm._e(),_c('Content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }